const { createContext } = require("react");

const WellMembersContext = createContext(null);

export default WellMembersContext;